import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import i18n from '@/i18n'

// Auth0
import { Auth0 } from '@/auth'

// UI
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
// VueMaterial theme is defined in App.vue

// Plugins
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'

// Components
import LoadingView from '@/components/LoadingView'
import NavBar from '@/components/NavBar'
import Slideshow from '@/components/Slideshow'
import Dialog from '@/components/Dialog'
import InputTree from '@/components/InputTree'
import InputTreeItem from '@/components/InputTreeItem'

// Include plugins
Vue.use(VueMaterial)
Vue.use(VueAwesomeSwiper)
Vue.use(Auth0, {
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    )
  }
})

// Include components
Vue.component('loading-view', LoadingView)
Vue.component('nav-bar', NavBar)
Vue.component('slideshow', Slideshow)
Vue.component('dialog-modal', Dialog)
Vue.component('input-tree', InputTree)
Vue.component('input-tree-item', InputTreeItem)

// Prevent the production tip on Vue startup
Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
